export const routesRaporOverall = [
  {
    path: "/rapor_overall",
    name: "rapor_overall",
    component: () => import("@/views/proje_alt/rapor_overall/index.vue"),
    meta: {
      public: false,
      title: "proje_alt.Overall Rapor",
      yetki: { k: [1012602] },
    },
  },
]
